import React from 'react';
import moment from 'moment';

interface Props {
  value: any;
}

export default function DataTempoPipe(props: Props) {

  if (!props.value) {
    return <></>;
  }
  let value = props.value;
  if (typeof value === 'object') {
    value = moment(value).format('YYYY-MM-DD HH:mm');
  }
  let data;
  if (value.indexOf('.') >= 0) {
    data = new Date(props.value.split('.')[0]);
  } else {
    data = new Date(props.value);
  }
  const dataStr = moment(data).format('DD/MM/YYYY HH:mm');
  return (
    <>
      {dataStr}
    </>
  );
}
